export default Object.freeze({
  A0: 1,
  A1: 2,
  A2: 3,
  A3: 4,
  A4: 5,
  A5: 6,
  RA0: 7,
  RA1: 8,
  RA2: 9,
  RA3: 10,
  RA4: 11,
  RA5: 12,
  B0: 13,
  B1: 14,
  B2: 15,
  B3: 16,
  B4: 17,
  B5: 18,
  Quarto: 19,
  Foolscap: 20,
  Executive: 21,
  GovernmentLetter: 22,
  Letter: 23,
  Legal: 24,
  Ledger: 25,
  Tabloid: 26,
  Post: 27,
  Crown: 28,
  LargePost: 29,
  Demy: 30,
  Medium: 31,
  Royal: 32,
  Elephant: 33,
  DoubleDemy: 34,
  QuadDemy: 35,
  STMT: 36,
  Folio: 37,
  Statement: 38,
  Size10x14: 39,
});
